import type { PeriodTypesRepositoryT } from "../../domain/ports/periodTypes.repository";

type ImportPeriodTypesParamsT = {
  periodTypesRepository: PeriodTypesRepositoryT;
  periodTypeId: string;
};

export const importPeriodTypes = ({
  periodTypesRepository,
  periodTypeId,
}: ImportPeriodTypesParamsT) => periodTypesRepository.import(periodTypeId);
